<div class="hidden md:flex flex-col items-center px-11">
	<div class="w-[516px]">
		<hr class="rotate-90 h-[1px] border-none bg-black w-full -mt-52" />
	</div>
	<hr class="w-full h-[1px] border-none bg-black" />
</div>
